import { render, staticRenderFns } from "./StatusIndicator2.vue?vue&type=template&id=028c2790&scoped=true"
import script from "./StatusIndicator2.vue?vue&type=script&lang=js"
export * from "./StatusIndicator2.vue?vue&type=script&lang=js"
import style0 from "./StatusIndicator2.vue?vue&type=style&index=0&id=028c2790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c2790",
  null
  
)

export default component.exports